// extracted by mini-css-extract-plugin
module.exports = {"trigger":"theme_trigger__6jTBJ","popover":"theme_popover__13MNh","addElementContainer":"theme_addElementContainer__18B-p","title":"theme_title__Qkmb5","body":"theme_body__2Lpag"};